export default __webpack_public_path__ + "static/media/221.ba3d60a1.png";